const columns = [
  { title: '话术ID', dataIndex: 'id', key: 'id', width: '100px' },
  { title: '话术内容', dataIndex: 'chatContent', key: 'chatContent' }
]

const paginationConfig = {
  current: 1,
  pageSize: 10,
  showQuickJumper: true,
  showSizeChanger: true,
  total: 0,
  size: 'small'
}

export { columns, paginationConfig }
